export default __webpack_public_path__ + "static/popup-pic-005-6884effb0b12b6d448a4fb2581a2a09d.jpg";